// extracted by mini-css-extract-plugin
export default {"wrapper":"Info_wrapper__2OLcq","info":"Info_info__Mr2uM","gender":"Info_gender__F5tE4","desc":"Info_desc__g8R+4","item":"Info_item__rkJ+s","activeTab":"Info_activeTab__Sanaf"};